import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { s as e, C as m } from "../../../../counterInput-C_wrWIup.js";
const v = ({
  label: r,
  onChange: c,
  errorMessage: i,
  inputInitialValue: o,
  maxValue: t,
  minValue: a,
  hasError: l,
  disabled: d
}) => /* @__PURE__ */ n("div", { className: e["group-container"], children: [
  /* @__PURE__ */ n("div", { className: e.label, children: [
    /* @__PURE__ */ s("div", { children: r }),
    l && i && /* @__PURE__ */ s("div", { className: e.error, children: i })
  ] }),
  /* @__PURE__ */ s(
    m,
    {
      inputInitialValue: o,
      minValue: a,
      maxValue: t,
      hasError: l,
      disabled: d,
      onChange: c
    }
  )
] });
export {
  v as Counter
};
